import React from 'react';
import { Scale } from 'lucide-react';
import { RULES } from '@/data/manual/rules';

export const RulesChapter = ({ query = '', groups }) => {
  const q = query.toLowerCase();
  const rules = RULES.filter((r) => (!groups || groups.has(r.group)) && (!q || `${r.title} ${r.text} ${r.group}`.toLowerCase().includes(q)));
  if (!rules.length) return null;
  const byGroup = rules.reduce((acc, r) => { (acc[r.group] ||= []).push(r); return acc; }, {});
  return (
    <section id="rules" data-testid="help-rules" className="rounded-2xl border border-amber-200 bg-amber-50/60 p-4 sm:p-6 scroll-mt-28 print-break">
      <header className="flex items-center gap-3">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-amber-500 text-white shrink-0"><Scale className="w-5 h-5" /></span>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-widest text-amber-800">Reference</div>
          <h3 className="text-xl sm:text-2xl font-bold text-[#27292E] leading-tight">Rules & automations</h3>
          <p className="text-sm text-gray-700 mt-1">Everything the portal does on its own, and the rules it holds everyone to.</p>
        </div>
      </header>
      <div className="mt-4 space-y-4">
        {Object.entries(byGroup).map(([g, list]) => (
          <div key={g}>
            <div className="text-xs font-bold uppercase tracking-wide text-amber-800 mb-1.5">{g}</div>
            <div className="grid gap-2 md:grid-cols-2">
              {list.map((r) => (
                <div key={r.id} data-testid={`rule-card-${r.id}`} className="rounded-lg bg-white border border-amber-200 p-3 break-inside-avoid">
                  <div className="text-sm font-bold text-[#27292E]">{r.title}</div>
                  <p className="text-sm text-gray-700 mt-1 leading-relaxed">{r.text}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
